(function () {
  const $ = (sel, root = document) => root.querySelector(sel);

  const wrap = $('#tc-map-tool');
  if (!wrap) return;

  const API_BASE = (wrap.dataset.api || '').replace(/\/+$/, '');
  const openBtn  = $('#tc-btn-open');
  const closeBtn = $('#tc-btn-close');
  const overlay  = document.getElementById('pendant3d-overlay');
  const fallback = document.querySelector('#pendant3d-overlay .pendant3d__fallback');
  const mapSrcEl = document.getElementById('MapSource'); // updated by your Leaflet code

  const getProductId = () => (wrap.dataset.product || 'custom-round-map-pendant-small').trim();

  // Inject light spinner CSS once
  (function ensureSpinnerCSS () {
    if (document.getElementById('tc-spinner-css')) return;
    const css = `
      .pendant3d__fallback{display:flex;align-items:center;justify-content:center;min-height:40px;color:#555}
      .tc-spinner{width:22px;height:22px;border:2px solid #ccc;border-top-color:#222;border-radius:50%;animation:tcspin .8s linear infinite;margin-right:8px}
      @keyframes tcspin{to{transform:rotate(360deg)}}
    `.trim();
    const s = document.createElement('style');
    s.id = 'tc-spinner-css';
    s.textContent = css;
    document.head.appendChild(s);
  })();

  const showSpinner = (el, text) => { if (!el) return; el.style.display = ''; el.innerHTML = `<span class="tc-spinner"></span> ${text || ''}`; };
  const hideFallback = (el) => { if (el) el.style.display = 'none'; };

  // Session cache so we don't refetch if coords+product didn't change
  let lastKey = null;
  let lastUrl = null;

  // AbortController: cancel in-flight build on new request
  let buildController = null;

  const getCoordZoom = () => (mapSrcEl && mapSrcEl.value || '').trim();
  const keyFor = (coordZoom, productId) => `${coordZoom}|preview|${productId}`;

  async function fetchBytes(url, init) {
    const res = await fetch(url, init);
    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error(`API ${res.status}: ${txt}`);
    }
    const ct = (res.headers.get('Content-Type') || '').toLowerCase();

    // If server returns JSON (e.g., { stl_url }), follow it to fetch the raw STL
    if (ct.includes('application/json')) {
      const j = await res.json();
      if (!j || !j.stl_url) throw new Error('No stl_url in JSON response.');
      const res2 = await fetch(j.stl_url, {
        mode: 'cors',
        headers: { 'Accept': 'application/sla, model/stl, application/octet-stream, */*' },
        signal: init && init.signal // propagate abort
      });
      if (!res2.ok) {
        const t2 = await res2.text().catch(() => '');
        throw new Error(`STL GET ${res2.status}: ${t2}`);
      }
      return await res2.blob();
    }
    return await res.blob(); // direct STL bytes
  }

  async function fetchPreviewSTL() {
    const coordZoom = getCoordZoom();
    const productId = getProductId();
    if (!coordZoom) throw new Error('Missing coordinates (MapSource).');
    if (!API_BASE) throw new Error('Missing data-api on #tc-map-tool.');

    const key = keyFor(coordZoom, productId);

    // Re-use cached STL if coords & product unchanged
    if (key === lastKey && lastUrl) return lastUrl;

    showSpinner(fallback, 'Building pendant…');

    // Latest-wins: abort any previous and create a fresh controller
    if (buildController) buildController.abort();
    buildController = new AbortController();

    const blob = await fetchBytes(`${API_BASE}/generate/${encodeURIComponent(productId)}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/sla, model/stl, application/octet-stream, */*'
      },
      body: JSON.stringify({ coord_zoom: coordZoom, mode: 'preview' }),
      signal: buildController.signal
    });

    const objUrl = URL.createObjectURL(blob);

    // Update cache; revoke old URL to avoid leaks
    if (lastUrl && lastUrl !== objUrl) { try { URL.revokeObjectURL(lastUrl); } catch (_) {} }
    lastKey = key;
    lastUrl = objUrl;

    return objUrl;
  }

  // -------------------------
  // A) Preview button (unchanged, immediate)
  // -------------------------
  async function onOpenClick() {
    try {
      document.dispatchEvent(new CustomEvent('tc:pendant-build-start'));
      if (fallback) showSpinner(fallback, 'Building pendant…');

      const stlUrl = await fetchPreviewSTL();
      window.TCPendantUI?.ready?.(stlUrl);
    } catch (err) {
      // ignore intentional cancellations; a newer request is in flight
      if (err && (err.name === 'AbortError' || /abort/i.test(String(err.message)))) return;
      console.error('[TC] STL preview failed:', err);
      if (fallback) { fallback.style.display = ''; fallback.textContent = 'Sorry — could not build preview.'; }
      document.dispatchEvent(new CustomEvent('tc:pendant-error', { detail: { message: 'Could not build preview.' } }));
    }
  }

  if (openBtn)  openBtn.addEventListener('click', onOpenClick);
  if (closeBtn) closeBtn.addEventListener('click', () => {
    hideFallback(fallback);
    if (overlay) overlay.classList.remove('is-open');
  });

  // Clear cache if MapSource changes
  if (mapSrcEl) ['input', 'change'].forEach(ev => mapSrcEl.addEventListener(ev, () => { lastKey = null; }));

  // -------------------------
  // B) Dual anti-bounce for rapid type taps
  //    - short leading tap guard (ignore bursts < TAP_GUARD_MS)
  //    - trailing debounce before firing build
  // -------------------------
  const REBUILD_DELAY_MS = 420;
  const TAP_GUARD_MS = 180;
  let rebuildTimer = null;
  let lastTypeTapAt = 0;

  const isOverlayOpen = () => wrap.classList.contains('overlay-open');

  async function rebuildWhileOpen() {
    if (!isOverlayOpen()) return; // don’t touch non-preview state
    try {
      document.dispatchEvent(new CustomEvent('tc:pendant-build-start'));
      if (fallback) showSpinner(fallback, 'Building pendant…');

      const stlUrl = await fetchPreviewSTL();
      window.TCPendantUI?.ready?.(stlUrl);
    } catch (err) {
      if (err && (err.name === 'AbortError' || /abort/i.test(String(err.message)))) return;
      console.error('[TC] STL preview (switch) failed:', err);
      document.dispatchEvent(new CustomEvent('tc:pendant-error', { detail: { message: 'Could not build preview.' } }));
    }
  }

  // Coalesce taps and rebuild if preview is open
  document.addEventListener('tc-shape-change', () => {
    const now = Date.now();
    if (now - lastTypeTapAt < TAP_GUARD_MS) return; // leading guard
    lastTypeTapAt = now;

    lastKey = null; // ensure different product re-evaluates cache
    if (!isOverlayOpen()) return;
    if (rebuildTimer) clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(rebuildWhileOpen, REBUILD_DELAY_MS);
  });

  // Allow a generic event to queue a build later
  document.addEventListener('tc:queue-build', () => {
    if (!isOverlayOpen()) return;
    if (rebuildTimer) clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(rebuildWhileOpen, REBUILD_DELAY_MS);
  });

  // Optional: clear cache on explicit coord changes
  document.addEventListener('tc:coords-changed', () => { lastKey = null; });
})();
